export default "__VITE_ASSET__CnRjmkqx__"